import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './components/layout/layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutModule } from './components/layout/layout.module';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ng2-cookies';
import { NetworkService } from './services/network.service';
import { SecurityService } from './services/security.service';
import { AuthguardService } from './services/authguard.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ReportingService } from './services/reporting.service';
import { OtpLoginComponent } from './components/otp-login/otp-login.component';
import { RecuperaPasswordComponent } from './components/recupera-password/recupera-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { HistoryDetailsFwpComponent } from './FASWhiteLabelPortal/pages/history-details-fwp/history-details-fwp.component';
import { ConditionalInterceptor } from './FASWhiteLabelPortal/interceptor/conditional.interceptor';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './FASWhiteLabelPortal/strategy/custom-reuse-strategy';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    OtpLoginComponent,
    RecuperaPasswordComponent,
    ChangePasswordComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgSelectModule,
  ],
  providers: [
    SecurityService,
    AuthguardService,
    CookieService,
    NetworkService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConditionalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    ReportingService,
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
